import React, { useState } from 'react';
// import styled from 'styled-components';
// import css from '@styled-system/css';
import { Modal } from 'antd';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import Datetime from 'react-datetime';
import { Text, Flex, Image, Box, Button } from 'atoms';
import { setinvoiceDate } from 'store/appSlice';
import Calendar from 'assets/calendar.svg';
import 'react-datetime/css/react-datetime.css';

// const days = [...Array(8).keys()].reverse();

const getdt = (item, format) => item.format(format);

const today = moment();
const last31DaysStart = today.clone().subtract(31, 'days');

function validDates(current) {
	return current.isBetween(last31DaysStart, today, null, '[]');
}

// const dates = days?.map((item) => ({
// 	id: item,
// 	date: getdt(item, 'DD'),
// 	day: getdt(item, 'ddd'),
// 	fullDate: getdt(item, 'YYYY-MM-DD'),
// }));

// const DayButton = styled(Button)`
// 	text-align: center;
// 	font-size: 12px;
// 	padding: 8px;
// 	${({ isSelected }) =>
// 		isSelected &&
// 		css({
// 			backgroundColor: 'YellowOrg',
// 			border: '1px solid YellowOrg',
// 			borderColor: 'YellowOrg',
// 		})}
// `;

export default function DateSelection() {
	const [visible, setVisible] = useState(false);
	const { invoiceDate } = useSelector((state) => state.app);
	const [date, setDate] = useState();
	const dispatch = useDispatch();

	const showModal = () => {
		setVisible(true);
	};

	const handleCancel = () => {
		setVisible(false);
	};

	const handleDateSelection = (data) => {
		dispatch(setinvoiceDate(data));
		handleCancel();
	};

	return (
		<>
			<Flex>
				<Box mr="5px">
					<Image src={Calendar} alt="calendar" />
				</Box>
				<Text textAlign="center" fontSize="12px" onClick={showModal}>
					{moment(invoiceDate).format('ddd Do MMM')}
				</Text>
			</Flex>

			<Modal
				width={360}
				footer={null}
				onCancel={handleCancel}
				visible={visible}
				closable
				centered
			>
				<Text textAlign="center" fontSize="14px" fontWeight="bold">
					Choose Date
				</Text>
				<Flex alignItems="center" justifyContent="space-between" my="2rem">
					{/* {dates?.map((item) => (
						<Flex
							key={item?.id}
							flexDirection="column"
							alignItems="center"
							justifyContent="space-between"
							onClick={() => handleDateSelection(item?.fullDate)}
						>
							<Text textAlign="center" fontSize="10px" onClick={showModal}>
								{item?.day}
							</Text>
							<DayButton isSelected={item?.fullDate === invoiceDate}>
								{item?.date}
							</DayButton>
						</Flex>
					))} */}
					<Datetime
						onChange={setDate}
						isValidDate={validDates}
						timeFormat={false}
						dateFormat="DD-MM-YYYY"
					/>
					<Button
						type="button"
						onClick={() => handleDateSelection(getdt(date, 'YYYY-MM-DD'))}
					>
						Submit
					</Button>
				</Flex>
			</Modal>
		</>
	);
}
